<script lang="ts">
  import ConfirmDialog from './ConfirmDialog.svelte';
  import { primerState, resolvePrimer } from './location-service.svelte';
</script>

{#if primerState.open}
  <ConfirmDialog
    title="Use your location?"
    message={`Lazy Traveler uses your location for ${primerState.feature ?? 'this feature'}. We don't store it.`}
    confirmLabel="Allow"
    cancelLabel="Not now"
    onConfirm={() => resolvePrimer(true)}
    onCancel={() => resolvePrimer(false)}
  />
{/if}
